var _excluded = ["title", "icon", "iconPosition", "text", "isVisible", "href", "to", "onClick", "openInNewTab"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
var Bulb = function Bulb(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.83 1a.8.8 0 0 0-1.6 0v2.031a.8.8 0 1 0 1.6 0V1Zm-1.666 18.332h-.856c-.11-1.001-.62-1.828-1.45-2.731l-.237-.249c-.21-.219-.482-.505-.529-.563a5 5 0 1 1 7.809.002c-.049.06-.343.369-.555.59v.001h-.001l-.209.22c-.829.902-1.34 1.729-1.45 2.73h-.855V16a.833.833 0 1 0-1.667 0v3.333Zm-.833 2.5V21h3.333v.834h-3.333Zm-4.958-8.41a6.666 6.666 0 0 0 1.42 3.41c.118.149.282.317.463.504.605.624 1.408 1.45 1.408 2.413v2.084a1.667 1.667 0 0 0 1.667 1.666h3.333a1.667 1.667 0 0 0 1.667-1.666v-2.084c0-.963.803-1.79 1.408-2.414.18-.185.343-.353.462-.5a6.667 6.667 0 1 0-11.828-3.413ZM18.05 1.82a.8.8 0 0 1 .3 1.09l-1.035 1.824a.8.8 0 1 1-1.391-.79l1.035-1.823a.8.8 0 0 1 1.09-.301ZM5.71 2.91a.8.8 0 0 1 1.391-.79l1.036 1.824a.8.8 0 0 1-1.391.79L5.71 2.911Zm16.756 3.387a.8.8 0 0 1-.197 1.114l-1.664 1.164a.8.8 0 1 1-.918-1.31L21.351 6.1a.8.8 0 0 1 1.115.197ZM1.724 7.41A.8.8 0 1 1 2.642 6.1l1.664 1.164a.8.8 0 0 1-.918 1.311L1.724 7.411Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
Bulb.defaultProps = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ArrowRight = function ArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m12 3-1.586 1.586 6.277 6.289H3v2.25h13.691l-6.277 6.289L12 21l9-9-9-9Z",
    fill: "#fff"
  }));
};
ArrowRight.defaultProps = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { zIndex } from "../../../settings";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getBoxShadowBorder from "../../../utils/getBoxShadowBorder";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import TextAtm from "../../atoms/TextAtm";
import Button from "../../quarks/Button";
import Link from "../../quarks/Link";

// eslint-disable-next-line no-shadow
export var IconAlign = /*#__PURE__*/function (IconAlign) {
  IconAlign["LEFT"] = "left";
  IconAlign["RIGHT"] = "right";
  return IconAlign;
}({});
var backgroundDarker = "backgroundDarker";
var borderRadius = "huge";
var Container = styled.div.withConfig({
  componentId: "sc-apjw4w-0"
})(function (_ref) {
  var $isHidden = _ref.$isHidden,
    $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["display:", ";position:fixed;z-index:", ";right:", ";bottom:", ";align-items:center;padding:", " ", ";border-radius:", ";background:", ";box-shadow:0 ", " ", " ", ",", ";cursor:pointer;&:hover{box-shadow:", ",", ";}", "{padding:", ";}"], $isHidden ? "none" : "inline-flex", zIndex.FloatingButtonMol, space(2), space(2), space(1.5), space(3), getBorderRadius(theme, borderRadius), getColor(theme, backgroundDarker), space(1.5), space(2), getBorderColor(theme, $onColor, "low"), getBoxShadow(theme, "medium"), getBoxShadowBorder(1, getBorderColor(theme, $onColor, "high")), getBoxShadow(theme, "big"), breakpoint("small", "medium"), space(1.5));
});
var Text = styled(TextAtm).withConfig({
  componentId: "sc-apjw4w-1"
})(function (_ref2) {
  var $iconPosition = _ref2.$iconPosition,
    theme = _ref2.theme;
  return css(["padding:0 ", " 0 ", ";> *{color:inherit;text-decoration:none;", "{span{display:none;}}&::after{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;border-radius:", ";}}", "{padding:0;}"], $iconPosition === IconAlign.LEFT ? 0 : space(1.5), $iconPosition === IconAlign.LEFT ? space(1.5) : 0, breakpoint("small", "medium"), getBorderRadius(theme, borderRadius), breakpoint("small", "medium"));
});
var SvgContainer = styled.div.withConfig({
  componentId: "sc-apjw4w-2"
})(function (_ref3) {
  var $iconPosition = _ref3.$iconPosition;
  return css(["display:flex;align-items:center;justify-content:center;order:", ";width:", ";height:", ";"], $iconPosition === IconAlign.LEFT ? 0 : 1, space(3), space(3));
});
function FloatingButtonMol(_ref4) {
  var title = _ref4.title,
    icon = _ref4.icon,
    _ref4$iconPosition = _ref4.iconPosition,
    iconPosition = _ref4$iconPosition === void 0 ? IconAlign.RIGHT : _ref4$iconPosition,
    text = _ref4.text,
    isVisible = _ref4.isVisible,
    href = _ref4.href,
    to = _ref4.to,
    onClick = _ref4.onClick,
    openInNewTab = _ref4.openInNewTab,
    restProps = _objectWithoutProperties(_ref4, _excluded);
  var onColor = useContext(OnColorContext);
  var svgIcon = icon || (iconPosition === IconAlign.LEFT ? /*#__PURE__*/React.createElement(Bulb, null) : /*#__PURE__*/React.createElement(ArrowRight, null));
  return /*#__PURE__*/React.createElement(Container, _extends({
    $isHidden: !isVisible,
    $onColor: onColor
  }, restProps), /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: backgroundDarker
  }, /*#__PURE__*/React.createElement(SvgContainer, {
    $iconPosition: iconPosition
  }, svgIcon), /*#__PURE__*/React.createElement(Text, {
    $iconPosition: iconPosition,
    typography: "small3"
  }, href || to ? /*#__PURE__*/React.createElement(Link, {
    openInNewTab: openInNewTab,
    title: title,
    href: href,
    to: to,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", null, text)) : /*#__PURE__*/React.createElement(Button, {
    title: title,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", null, text)))));
}
export default FloatingButtonMol;